import React from 'react'
import { Form, Input, Button } from 'antd'
import { func } from 'prop-types'

import { useCreatePumpingSystem } from '@graphql/mutations'

function ManagePumpingSystemForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createPumpingSystem, { loading }] = useCreatePumpingSystem()

  const onFinish = data => {
    createPumpingSystem({
      variables: {
        data: { ...data },
      },
      refetchQueries: ['GetPumpingSystemsQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome do sistema de bombagem" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar sistema de bombagem
      </Button>
    </Form>
  )
}

ManagePumpingSystemForm.propTypes = {
  afterSubmit: func,
}

ManagePumpingSystemForm.defaultProps = {
  afterSubmit: null,
}

export default ManagePumpingSystemForm
